import { render } from "./Presentacion.vue?vue&type=template&id=2403dff6"
import script from "./Presentacion.vue?vue&type=script&lang=js"
export * from "./Presentacion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__